/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Unterstuetzungsbedarf1Inputs */

const en__field_unterstuetzungsbedarf1 = /** @type {(inputs: _Field_Unterstuetzungsbedarf1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need for support`)
};

const de__field_unterstuetzungsbedarf1 = /** @type {(inputs: _Field_Unterstuetzungsbedarf1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützungsbedarf`)
};

/**
* | output |
* | --- |
* | "Need for support" |
*
* @param {_Field_Unterstuetzungsbedarf1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_unterstuetzungsbedarf1 = /** @type {((inputs?: _Field_Unterstuetzungsbedarf1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Unterstuetzungsbedarf1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_unterstuetzungsbedarf1(inputs)
	return de__field_unterstuetzungsbedarf1(inputs)
});
export { _field_unterstuetzungsbedarf1 as "_field_unterstuetzungsBedarf" }